// extracted by mini-css-extract-plugin
module.exports = {"section":"software_section__3-5Xk","content":"software_content__2-w9r","documentaryCTA":"software_documentaryCTA__qj-eO"};